    <template >
  <div v-role="'prof'">
  <div>
  <div class="formPosition">
    <template>

      <!--  classes em aue se tem discplinas  -->
      <v-container

        v-if="!disciplinas.length"
        class="grey lighten-5"
      >
        <v-row no-gutters>
          <v-col>
            Lancar nota -
            <strong>FINALISTA</strong>
            <br />

            <span v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso">Selecione a classe e em seguida as turmas</span>

            <v-icon v-if="!progresso" large color="green darken-2">forward</v-icon>
            <span v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso">Nenhuma turma para ser exibida.</span>
            <br />
            <span v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso">- Certifica-se de que tenha as permissôes correctas.</span>
            <br v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso" />
            <span
              v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso"
            >- Caso estejas logado com uma conta de Sub-director pedagógico ou de coordenador, provalvemente nao existam turmas criadas. Deverá cria-las e atribuir a no mínimo um professor.</span>
            <br v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso" />
            <span
              v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso"
            >- Caso estejas logado com uma conta de professor, pode não ter sido atrbuida turmas a sí. Contacte o Sub-director pedagógico. Obrigado</span>
            <br v-if="!listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso" />

            <div class="text-center" v-if="progresso">

                <!--================PROGRESSO===========================-->
                  <span v-if="progresso">Procurando por turmas , por favor aguarde...</span>

                  <v-progress-circular
                          v-if="progresso"
                          indeterminate
                          color="green"
                  ></v-progress-circular>

              <!--===================/Progresso=====================-->

            </div>

            <div v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso" class="text-center">

              <v-btn
                @click="classe(4)"
                v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===4).length && !progresso"
                class="ma-2"
                outlined
                color="indigo"
              >
                <v-icon small color="primary">filter_4</v-icon>13ª classe
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <!--  list turmas  -->
      <v-container>
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"   -->
            <template
              v-if="!disciplinas.length&&listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length"
            >
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-list flat>
                        <v-subheader>você tem {{listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length}} Turma(s) da {{_classe }}. clica em uma para prosseguir</v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list-item
                            v-for="(item, i) in listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico)"
                            :key="i"
                          >
                            <v-list-item-icon>
                              <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>

                            <v-list-item-content color="primary" dark v-on="on">
                              <v-list-item-title
                                v-text="item.descricao"
                                @click="findDisciplinaInProfDisc(item)"
                              ></v-list-item-title>

                              <v-list-item-subtitle @click="findDisciplinaInProfDisc(item)">
                                <strong>{{item.estudantes}}</strong>
                                estudantes na turma - Periodo {{item.periodo}}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>

      <!--  list disciplinas  -->
      <v-container v-if="disciplinas.length && !listEstudantfromPauta.length">
        <v-row no-gutters>
          <v-col>
            <!-- v-if="!listEstudantfromPauta.length"   -->

            <template v-if="listaDeClassesPorLancarNotas.filter(turma =>turma.idAno_Academico===idanoacademico).length">
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-btn
                        @click="backToTurmaList"
                        class="mx-2"
                        fab
                        dark
                        color="primary"
                        v-on="on"
                      >
                        <v-icon dark>arrow_back</v-icon>
                      </v-btn>
                      <v-list flat>
                        <v-subheader>
                          você tem {{disciplinas.length}} disciplina(s) na {{this.$store.state.turma}} . Seleciona uma para prosseguir
                          <br />
                          <br />
                        </v-subheader>
                        <v-list-item-group v-model="item" color="primary">
                          <v-list>
                            <v-list-item v-for="(item, index) in disciplinas" :key="index">
                              <v-list-item-title
                                v-text="item.descricao"
                                @click="pautaByTurma(item)"
                              ></v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>

          <v-col></v-col>
        </v-row>
      </v-container>
      <!--  fim discp  -->
    </template>
  <!--=========================DIALOGO DE DESBLOQUEIO DA PAUTA============================================-->

         <template>
              <v-row justify="center">
                <v-dialog
                  v-model="dialogoDisabilita"
                  max-width="500"
                >
                  <v-card>
                    <v-card-title class="headline">Desbloquear  Pauta</v-card-title>

                    <v-card-text>
                     <strong> NOTA:</strong>----Ao publicar a pauta , não será possivel fazer alterações nas notas,<strong> pretende continuar</strong>?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="red darken-1"
                        text
                        @click="dialogoDisabilita = false"
                      >
                        Cancelar
                      </v-btn>

                          <v-btn
                            color="green darken-1"
                            text
                            @click="DesbloquearPauta()"
                          >
                            Desbloquear
                          </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

  <!--=========================FIM DO DIALOGO DE DESBLOQUEIO DA PAUTA============================================-->

  <!--======================DIALOGO DEPUBLICAOCAO=============================================--=======-->

            <template>
              <v-row justify="center">
                <v-dialog
                  v-model="dialog"
                  max-width="500"
                >
                  <v-card>
                    <v-card-title class="headline">Publicação da Pauta</v-card-title>

                    <v-card-text>
                     <strong> NOTA:</strong>----Ao publicar a pauta , não será possivel fazer alterações nas notas,<strong> pretende continuar</strong>?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="red darken-1"
                        text
                        @click="dialog = false"
                      >
                        Cancelar
                      </v-btn>

                      <v-btn
                        color="green darken-1"
                        text
                        @click="PublicarPauta()"
                      >
                        Continuar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

  <!--======================FIM DIALOGO DE PUBLICAOCAO==============================================--=======-->

  <template v-if="listEstudantfromPauta.length">

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
                <v-btn @click="backTodisciplinList" class="mx-2" fab dark color="primary" v-on="on">
                  <v-icon dark>arrow_back</v-icon>
                </v-btn>
                <v-header>
                   <div style="text-align:center">
                  clica
                  <v-icon  small class="mr-2">edit</v-icon>para lancar nota de
                  <strong>{{listEstudantfromPauta[0].disciplina}}</strong> na turma:
                  <strong>{{this.$store.state.turma}}</strong> <br>
                <strong>NOTA FINALISTA   </strong>{{descricao_Prof}} : <strong>{{Professor}}</strong>

                </div>
                <div
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>

                     <v-row>
                        <v-col cols="6" sm="6 ">

                           <v-btn
                              class="ma-2"
                              color="info"
                              style="float:right"
                              v-if="(role_usuario ==='ROLE_PROF')?false:true"
                              :disabled="btn_description === 'Publicar'"
                              @click="MostrarDialogoDisabilitar()"
                            >
                              Desbloquear

                            </v-btn>

                        </v-col>
                        <v-col>

                            <v-btn
                              class="ma-2"
                              color="info"
                              style="float:right"
                            :disabled="publicar_status || btn_description === 'Mini Pauta Bloqueada aos Professores'"
                              @click="MostrarDialogo()"
                            >
                              {{btn_description}}

                            </v-btn>
                        </v-col>
                     </v-row>

                </v-header>
                <hr width="1200px" />

                <v-list-item-group v-model="item" color="primary">

                  <!--  Nota Finalista  header -->
                  <v-row v-if="this.$store.state.idperfilpauta==3" style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="8">Nome</v-col>

                    <v-col cols="12" sm="12" md="1">Nota</v-col>

                    <v-col cols="12" sm="12" md="2">Action</v-col>
                  </v-row>

                  <!-- end  list  header  -->

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                 <v-row   v-if="$store.state.idperfilpauta==1">
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="8">
                        <v-list-item-title v-text="item.nome"></v-list-item-title>

                      </v-col>

                      <v-col cols="12" sm="12" md="1">
                        <p v-if="editedpk!==item.pkpauta" class="text-lowercase">{{item.p1_MD}}</p>
                        <v-text-field :rules="notaRules"
                          v-if="editedpk===item.pkpauta"
                          v-model="editedItem.p1_notaMac"
                          single-line
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="2">
                        <v-btn
                          color="secondary"
                          fab
                          x-small
                          dark
                          :disabled="btn_activacao1"
                          v-if="editedpk!==item.pkpauta"
                          class="mr-2"
                          @click="bt_edit(item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>

                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          v-if="editedpk===item.pkpauta"
                          @click="bt_save(editedItem)"
                        >
                          <v-icon>save_alt</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    text: '',
    editedpk: false,
    profediscinas: [],
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialogoDisabilita: false,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    progresso: true,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    this.turmaFindWithEstudanteCount('all')
    this.CarregaPautas()
    this.initprofdisc()
    this.role_usuario = ls.get('role')
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      if (this.formValid) {
        this.save(editedItem)
        this.listEstudantfromPauta[this.editedIndex].p1_MD = this.editedItem.p1_MD
        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        console.log(this.listaDeClassesPorLancarNotas.filter(t => t.idAno_Academico === 4))
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {
      const ls = require('local-storage')
      var params = {
        nota: editedItem.p1_notaMac,
        pkpauta: editedItem.pkpauta
      }
      try {
        let valor = await axios

          .post('/lancarNotaFinalista', params)
          .then(res => res.data)
        let text = valor
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async pautaByTurma (obj) {
      // carrega turma apartir de bauta  Turma
      this.$store.state.disciplina = obj.iddisciplina
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get('i_id') +
        '"  }'

      try {
        this.listEstudantfromPauta = await axios

          .get('/listEstudantfromPauta/' + payload)
          .then(res => res.data)
        console.log(this.listEstudantfromPauta)

        this.verificaPautas()

        this.MostraProfessor()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            trimestre: this.$store.state.lancarNotaDe,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado.push(valores)
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas()
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              trimestre: this.$store.state.lancarNotaDe,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    async CarregaPautas () {
      if (!this.$store.state.bloqueado.length) {
        try {
          this.$store.state.bloqueado = await axios

            .get('/ListarPautaBloqueada')
            .then(res => res.data)
          console.log(this.$store.state.bloqueado)
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina == this.$store.state.disciplina && block.publicar == 1 && block.bloquear == 1 && block.trimestre === this.$store.state.lancarNotaDe)
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      // console.log("vervcv rexmsg:"+ Object.values(obj))
      try {
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
